import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=b31152fc&scoped=true&"
import script from "./HomeScreen.vue?vue&type=script&lang=ts&"
export * from "./HomeScreen.vue?vue&type=script&lang=ts&"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=b31152fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31152fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
